function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); Object.defineProperty(Constructor, "prototype", { writable: false }); return Constructor; }

function _get() { if (typeof Reflect !== "undefined" && Reflect.get) { _get = Reflect.get; } else { _get = function _get(target, property, receiver) { var base = _superPropBase(target, property); if (!base) return; var desc = Object.getOwnPropertyDescriptor(base, property); if (desc.get) { return desc.get.call(arguments.length < 3 ? target : receiver); } return desc.value; }; } return _get.apply(this, arguments); }

function _superPropBase(object, property) { while (!Object.prototype.hasOwnProperty.call(object, property)) { object = _getPrototypeOf(object); if (object === null) break; } return object; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); Object.defineProperty(subClass, "prototype", { writable: false }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } else if (call !== void 0) { throw new TypeError("Derived constructors may only return object or undefined"); } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

/**
 * @license
 * Copyright (c) 2021 - 2023 Vaadin Ltd.
 * This program is available under Apache License Version 2.0, available at https://vaadin.com/license/
 */

/**
 * Array of Vaadin custom element classes that have been subscribed to the dir changes.
 */
var directionSubscribers = [];

function alignDirs(element, documentDir) {
  var elementDir = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : element.getAttribute('dir');

  if (documentDir) {
    element.setAttribute('dir', documentDir);
  } else if (elementDir != null) {
    element.removeAttribute('dir');
  }
}

function getDocumentDir() {
  return document.documentElement.getAttribute('dir');
}

function directionUpdater() {
  var documentDir = getDocumentDir();
  directionSubscribers.forEach(function (element) {
    alignDirs(element, documentDir);
  });
}

var directionObserver = new MutationObserver(directionUpdater);
directionObserver.observe(document.documentElement, {
  attributes: true,
  attributeFilter: ['dir']
});
/**
 * A mixin to handle `dir` attribute based on the one set on the `<html>` element.
 *
 * @polymerMixin
 */

export var DirMixin = function DirMixin(superClass) {
  return /*#__PURE__*/function (_superClass) {
    _inherits(VaadinDirMixin, _superClass);

    var _super = _createSuper(VaadinDirMixin);

    function VaadinDirMixin() {
      _classCallCheck(this, VaadinDirMixin);

      return _super.apply(this, arguments);
    }

    _createClass(VaadinDirMixin, [{
      key: "__isRTL",
      get:
      /**
       * @return {boolean}
       * @protected
       */
      function get() {
        return this.getAttribute('dir') === 'rtl';
      }
      /** @protected */

    }, {
      key: "connectedCallback",
      value: function connectedCallback() {
        _get(_getPrototypeOf(VaadinDirMixin.prototype), "connectedCallback", this).call(this);

        if (!this.hasAttribute('dir') || this.__restoreSubscription) {
          this.__subscribe();

          alignDirs(this, getDocumentDir(), null);
        }
      }
      /** @protected */

    }, {
      key: "attributeChangedCallback",
      value: function attributeChangedCallback(name, oldValue, newValue) {
        _get(_getPrototypeOf(VaadinDirMixin.prototype), "attributeChangedCallback", this).call(this, name, oldValue, newValue);

        if (name !== 'dir') {
          return;
        }

        var documentDir = getDocumentDir(); // New value equals to the document direction and the element is not subscribed to the changes

        var newValueEqlDocDir = newValue === documentDir && directionSubscribers.indexOf(this) === -1; // Value was emptied and the element is not subscribed to the changes

        var newValueEmptied = !newValue && oldValue && directionSubscribers.indexOf(this) === -1; // New value is different and the old equals to document direction and the element is not subscribed to the changes

        var newDiffValue = newValue !== documentDir && oldValue === documentDir;

        if (newValueEqlDocDir || newValueEmptied) {
          this.__subscribe();

          alignDirs(this, documentDir, newValue);
        } else if (newDiffValue) {
          this.__unsubscribe();
        }
      }
      /** @protected */

    }, {
      key: "disconnectedCallback",
      value: function disconnectedCallback() {
        _get(_getPrototypeOf(VaadinDirMixin.prototype), "disconnectedCallback", this).call(this);

        this.__restoreSubscription = directionSubscribers.includes(this);

        this.__unsubscribe();
      }
      /** @protected */

    }, {
      key: "_valueToNodeAttribute",
      value: function _valueToNodeAttribute(node, value, attribute) {
        // Override default Polymer attribute reflection to match native behavior of HTMLElement.dir property
        // If the property contains an empty string then it should not create an empty attribute
        if (attribute === 'dir' && value === '' && !node.hasAttribute('dir')) {
          return;
        }

        _get(_getPrototypeOf(VaadinDirMixin.prototype), "_valueToNodeAttribute", this).call(this, node, value, attribute);
      }
      /** @protected */

    }, {
      key: "_attributeToProperty",
      value: function _attributeToProperty(attribute, value, type) {
        // Override default Polymer attribute reflection to match native behavior of HTMLElement.dir property
        // If the attribute is removed, then the dir property should contain an empty string instead of null
        if (attribute === 'dir' && !value) {
          this.dir = '';
        } else {
          _get(_getPrototypeOf(VaadinDirMixin.prototype), "_attributeToProperty", this).call(this, attribute, value, type);
        }
      }
      /** @private */

    }, {
      key: "__subscribe",
      value: function __subscribe() {
        if (!directionSubscribers.includes(this)) {
          directionSubscribers.push(this);
        }
      }
      /** @private */

    }, {
      key: "__unsubscribe",
      value: function __unsubscribe() {
        if (directionSubscribers.includes(this)) {
          directionSubscribers.splice(directionSubscribers.indexOf(this), 1);
        }
      }
    }], [{
      key: "properties",
      get: function get() {
        return {
          /**
           * @protected
           */
          dir: {
            type: String,
            value: '',
            reflectToAttribute: true,
            converter: {
              fromAttribute: function fromAttribute(attr) {
                return !attr ? '' : attr;
              },
              toAttribute: function toAttribute(prop) {
                return prop === '' ? null : prop;
              }
            }
          }
        };
      }
    }]);

    return VaadinDirMixin;
  }(superClass);
};